import React, { useState, useEffect } from "react";
import BuyerSidebar from "./common/BuyerSidebar";
import { Link } from "react-router-dom";
import WishlistCard from "./comoponent/WishlistCard";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import ProfileSidebar from "../pages/common/ProfileSidebar";

const Wishlist = () => {
  const handleMoveToCart = () => {
    alert("Item moved to cart!");
  };

  // Dummy data (10+ items for pagination demo)
  const wishlistItems = Array.from({ length: 12 }, (_, i) => ({
    id: i + 1,
    productImage: "/images/woolen_cloths.jpg",
    productName: "Woolen Clothes for elders",
    productBy: "YMCA Foundation",
    price: 200,
  }));

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(9); // show 8 cards per page

  // Calculate paginated data
  const totalCounts = wishlistItems.length;
  const totalPage = Math.max(1, Math.ceil(totalCounts / limit));
  const startIndex = (currentPage - 1) * limit;
  const currentWishlist = wishlistItems.slice(startIndex, startIndex + limit);

  useEffect(() => {
    setCurrentPage(1); // reset when limit changes
  }, [limit]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">My Account</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Wishlist
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <ProfileSidebar />
              </div>

              <div className="col-lg-9 my_orders">
                <h5 className="">Wishlist</h5>

                {/* Wishlist grid */}
                <div className="wishlist-grid">
                  {currentWishlist.map((item) => (
                    <WishlistCard
                      key={item.id}
                      productImage={item.productImage}
                      productName={item.productName}
                      productBy={item.productBy}
                      price={item.price}
                      onMoveToCart={handleMoveToCart}
                    />
                  ))}
                </div>

                {/* Pagination */}
                <div className="pages_liststs">
                  <CommanPagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    totalCounts={totalCounts}
                    totalPage={totalPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Wishlist;
